import React from 'react';
import Banner from "./banner"
import OurMission from "./ourMission"
import OurCoreValues from "./ourCoreValues"
import OurMilestones from "./ourMilestones"
import JoinUs from "./joinUs"


const Culture = () => {
  return ( 
    <div>
      < Banner /> 
      < OurMission />
      < OurCoreValues />
      < OurMilestones />
      < JoinUs />
    </div>
   );
}
 
export default Culture;